import { Datetime } from "aws-sdk/clients/costoptimizationhub";
import { CallEmsApi, iEmsApiResponseBody } from "../../Logic/EmsAPI/FetchExtension";
import store from "../../state/store";
export interface alarmsDTO {
    alarmAt: string;
    enabled?: boolean;
    enquiryID: number;
    notes?: string;
    id: number;
    subject: string;
    originalAlarmAt: string;
}

export interface GetUserAlarmsResponse {
    alarms: alarmsDTO[];
}
export async function GetUserAlarmsData(): Promise<iEmsApiResponseBody<GetUserAlarmsResponse>> {
    let user = store.getState().UserInformation;
    return await CallEmsApi<GetUserAlarmsResponse>("GET", `Users/${user.userID}/Alarms`);
}
export async function DeleteUserAlarmsData(alarmId: number) {
    let user = store.getState().UserInformation;
    return await CallEmsApi<any>("DELETE", `Users/${user.userID}/Alarms/${alarmId} `);
}
export async function UpdateUserAlarmsData(alarmId: number, alarmRequest: UpdateAlarmRequest) {
    let user = store.getState().UserInformation;
    return await CallEmsApi<any>("PUT", `Users/${user.userID}/Alarms/${alarmId} `, alarmRequest);
}
export interface UpdateAlarmRequest {
    AlarmAt: Datetime;
    Subject: string;
    Notes?: string;
}
